<dx-load-panel
               [message]="message"
               [showIndicator]="true"
               shadingColor="rgba(128,128,128,.3)"
               [shading]="isModal"
               [visible]="showLoadingPanel"></dx-load-panel>
